<template>
    <rkm-area
        no-margin-top
        title="Motivo do atendimento"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.geral.ciap"
                    :request-query-string-params="{sexo_id: data.form.paciente.sexoId}"
                    :search-fields="fields"
                    :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                    :results-limit= "20"
                    label="CIAP 2"
                    v-model="data.model.preAtendimento.ciap"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.motivoAtendimento"
                    name="Motivo do atendimento"
                    rows="4"
                    v-model="data.model.preAtendimento.motivoAtendimento"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Mixins.
import {repository} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                motivoAtendimento: {max: 5000},
            }
        },
    },
    created() {
        this.repositories = {
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        fields: [
            {key: 'geral_ciap.codigo', searchable: true},
            {key: 'geral_ciap.descricao', searchable: true},
        ],
    }),
    mixins: [repository],
    props: {
        data: {type: Object, required: true},
    },
}
</script>